/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TMarkOffersAsViewedModel,
  IMarkOffersAsViewedRequest,
  IMappers,
  IMarkOffersAsViewedResponse,
  IMarkOffersAsViewedResponseError,
  TMarkOffersAsViewedResponse,
} from './types';

const defaultConfig: TMarkOffersAsViewedModel = {
  apiType: 'public',
  assertStatusCodes: [400, 200, 204],
  method: 'POST',
  microserviceName: 'viewed-offers',
  pathApi: '/v1/mark-offers-as-viewed/',
  hostType: 'api',
} as TMarkOffersAsViewedModel;

function createMarkOffersAsViewedModel(parameters: IMarkOffersAsViewedRequest): TMarkOffersAsViewedModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IMarkOffersAsViewedOptions<TResponse400, TResponse200, TResponse204> {
  httpApi: IHttpApi;
  parameters: IMarkOffersAsViewedRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400, TResponse200, TResponse204>;
}

async function fetchMarkOffersAsViewed<TResponse400, TResponse200, TResponse204>({
  httpApi,
  parameters,
  config,
  mappers,
}: IMarkOffersAsViewedOptions<TResponse400, TResponse200, TResponse204>): Promise<
  TResponse400 | TResponse200 | TResponse204 | TMarkOffersAsViewedResponse
> {
  const { response, statusCode } = await httpApi.fetch(createMarkOffersAsViewedModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IMarkOffersAsViewedResponseError);
    }

    if (statusCode === 200) {
      return mappers[200](response as IMarkOffersAsViewedResponse);
    }

    if (statusCode === 204) {
      return mappers[204]();
    }
  }

  return { response, statusCode } as TMarkOffersAsViewedResponse;
}

export { defaultConfig, createMarkOffersAsViewedModel, fetchMarkOffersAsViewed };
